import React from 'react';
import { AccessibiltyInfo } from './styles';
import { getAccessibilityInfo } from './utils';
import { arrayOf, shape, string, bool } from 'prop-types';

function Accessibility({ accessibility }) {
  const info = getAccessibilityInfo(accessibility);

  return <AccessibiltyInfo>{info}</AccessibiltyInfo>;
}

Accessibility.propTypes = {
  accessibility: arrayOf(
    shape({
      name: string.isRequired,
      _entity_id: string,
      _entity_type: string,
      aliases: arrayOf(string),
      global: bool
    })
  ).isRequired
};

export default Accessibility;
